<template>
  <sec-page>
    <sec-hero centered :title="c.hero.title" :lede="c.hero.lede" />
    <sec-section :divider="false">
      <sec-story-grid :items="c.stories.items" :label="c.stories.label" :read-more="c.stories.readMore" />
    </sec-section>
    <get-in-touch-section heading-id="customers-get-in-touch" />
  </sec-page>
</template>

<script setup>
// Secure AI Adoption Customer Stories. Served at "/customers" when SITE_MODE is 'security'
// (src/router/index.js); the legacy src/views/customers/CustomersVue.vue and the story pages
// are untouched.
import SecPage from '@/components/security/ui/SecPage.vue';
import SecHero from '@/components/security/ui/SecHero.vue';
import SecSection from '@/components/security/ui/SecSection.vue';
import SecStoryGrid from '@/components/security/ui/SecStoryGrid.vue';
import GetInTouchSection from '../shared/GetInTouchSection.vue';
import { CUSTOMERS } from '@/content/security/customers';

const c = CUSTOMERS;
</script>
